/**
 * subtotalPage를 통해 chapter와 page를 리턴합니다.
 */
export function getChapterAndPage({
  subTotalPage,
  chapterPageCountList,
}: {
  subTotalPage: number;
  chapterPageCountList?: number[];
}) {
  if (!chapterPageCountList) {
    return {chapterId: undefined, page: 1};
  }

  let newChapterId;
  let pagesLeft = subTotalPage || 1;
  for (let i = 0; i < chapterPageCountList.length; i++) {
    const chapterPageCount = chapterPageCountList[i] ?? 0;
    if (pagesLeft - chapterPageCount > 0) {
      pagesLeft -= chapterPageCount;
    } else {
      newChapterId = i;
      break;
    }
  }

  return {chapterId: newChapterId, page: pagesLeft};
}
